import { Popover, Card, Menu, Icon, Button, Text, Stack } from '@chaser/components';
import { setShortCode } from '@/duck/actions/organisation';
import { useDispatch } from 'react-redux';

function SwapOrganisationsMenu({ organisation, organisations }) {
  const selected = organisations?.find(org => org.ShortCode === organisation?.ShortCode);
  const { name, Name } = selected || {};
  const orgName = name || Name || 'Select an organisation';

  if (!organisations || organisations.length < 2) return null;

  const dispatch = useDispatch();

  const handleOrganisationSwitch = shortCode => {
    dispatch(setShortCode(shortCode));
    window.location.assign(`/o/${shortCode}`);
  };

  return (
    <Stack alignItems="center">
      <Text fontWeight="bold" color="Mid Neutral 1">
        Change organisations
      </Text>
      <Popover
        target={
          <Button appearance="secondary" size="narrow">
            {orgName} <Icon name="arrow-down" size="8" />
          </Button>
        }
      >
        <Card scrollable data-testid="org-dropdown-menu" data-trackingid="org-dropdown-menu">
          <Menu>
            <Menu.Divider />
            {organisations.map((org, i) => (
              <Menu.Item
                data-testid={`org-dropdown-menu_item_${org.name}`}
                data-trackingid={`org-dropdown-menu_item_${org.name}`}
                key={i}
                onClick={() => {
                  handleOrganisationSwitch(org.ShortCode);
                }}
              >
                {org.name || org.Name}
              </Menu.Item>
            ))}
          </Menu>
        </Card>
      </Popover>
    </Stack>
  );
}

export default SwapOrganisationsMenu;
